import { PayloadAction } from '@reduxjs/toolkit';

import { getAllSizes } from 'productTemplate/utils/getAllSizes';
import { getAvailableSizesPrioritizedByCondition } from 'shared/utils/getLowestPriceVariantsPrioritizedByCondtion';
import { getNewAvailableSizes } from 'productTemplate/utils/getNewAvailableSizes';
import { getSizeOptionsMap } from 'productTemplate/utils/getSizeOptionsMap';

import { IBuyBarProductVariant } from 'shared/types/BuyBarProductVariant';
import { IPdp } from 'store/types/pdpTypes';
import { IProductTemplate } from 'shared/types/ProductTemplate';
import { IConsumerSearchFactsWindowData } from 'productTemplate/types/FactsWindowData';
import { IFeaturedInCollection } from 'productTemplate/types/FeaturedInCollection';

export const setProductTemplateData = (
  state: IPdp,
  action: PayloadAction<{
    productTemplate: IProductTemplate;
    factsWindowData: IConsumerSearchFactsWindowData;
    featuredInCollections: IFeaturedInCollection[];
  }>,
) => {
  const { productTemplate, factsWindowData, featuredInCollections } = action?.payload;
  if (productTemplate) {
    state.productTemplate = productTemplate;
  }

  if (factsWindowData) {
    state.factsWindowData = factsWindowData;
  }

  if (featuredInCollections) {
    state.featuredInCollections = featuredInCollections;
  }
};

export const setBuyBarVariants = (state: IPdp, action: PayloadAction<IBuyBarProductVariant[]>) => {
  const buyBarData = action.payload;
  const { sizeOptions } = state.productTemplate;

  const sizeOptionsMap = getSizeOptionsMap(sizeOptions);
  const { availableSizes, mapSizeToVariants, usedVariant } =
    getAvailableSizesPrioritizedByCondition(buyBarData, false, sizeOptionsMap);

  state.buyBarVariants.allSizes = getAllSizes(sizeOptions, availableSizes);
  state.buyBarVariants.availableSizes = availableSizes;
  state.buyBarVariants.newAvailableSizes = getNewAvailableSizes(buyBarData);
  state.buyBarVariants.usedAvailableSizes = usedVariant;
  state.buyBarVariants.mapSizeToVariants = mapSizeToVariants;
};
